import { styled } from '../../theming';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { Inline } from '../../Layout';

const NavBarGate = styled(Inline)`
  margin: 0 auto;
  // 1200px = 1168px + 16px left padding + 16px right padding
  // This max content width and the padding is based on https://www.figma.com/file/4eNN9OO6wzlTLyQqThYWmW/Viewports
  max-width: 1200px;
  min-height: ${tokens.size.x16};

  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    height: ${tokens.size.x16};
  }
`;

export default NavBarGate;
